<script>
	import { localizeHref } from '@/paraglide/runtime';
</script>

<svelte:head>
	<title>Zarpar | Aviso legal</title>
	<meta name="description" content="Aviso legal" />
</svelte:head>

<div class="mx-auto max-w-3xl px-2 py-14 md:px-0">
	<div class="max-w-150 relative mx-auto pb-24 text-center">
		<h1 class="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Aviso legal</h1>
		<p class="mt-4 text-base leading-7 text-slate-600">Ultima actualización 01/09/2025</p>
	</div>

	<div
		class="prose prose-sm prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600 max-w-160 mx-auto"
	>
		<ol class="list-inside list-decimal space-y-2">
			<li class="text-lg font-semibold">Titularidad del sitio web</li>
			<p>
				Este sitio web es titularidad de <strong>PLATAFORMA NÁUTICA DIGITAL S.L.</strong>, con NIF
				B19964188, con domicilio a efectos de notificaciones en C/ Pi y Margall, 18 – 2ºC, CP 36202
				en Vigo (Pontevedra), inscrita en el Registro Mercantil de Pontevedra Sección 8 , Hoja PO
				73758, I/A 1, con dirección de correo electrónico:
				<a href="mailto:info@zarpar.eu" class="font-semibold text-sky-500 hover:text-sky-600"
					>info@zarpar.eu</a
				>. En adelante, “ZARPAR”.
			</p>
			<li class="mt-4 text-lg font-semibold">Objeto</li>
			<p>
				El presente Aviso Legal, junto con la Política de Privacidad y la Política de Cookies,
				tienen por objeto regular la navegación y condiciones de uso de la página web de ZARPAR
				<a href={localizeHref('/')} class="font-semibold text-sky-500 hover:text-sky-600"
					>https://zarpar.eu</a
				> (en adelante, el “Sitio Web”). El acceso, navegación y/o uso del Sitio Web le identifican como
				Usuario, y con ello usted acepta este Aviso legal junto con la Política de Privacidad y Política
				de Cookies, sin perjuicio de que ZARPAR pueda establecer condiciones particulares (Términos y
				Condiciones) que regulen la utilización, prestación y/o contratación de los productos o servicios
				que, en su caso, puedan ser ofrecidos a través del Sitio Web.
			</p>
			<p>
				Respecto de la utilización, prestación y/o contratación de servicios ofrecidos en el Sitio
				Web, el hecho de ser utilizados y/o solicitados por el Usuario implicará, asimismo, la
				aceptación sin reservas de las condiciones particulares (Términos y Condiciones).
			</p>
			<p>
				ZARPAR se reserva la facultad de ofrecer determinados servicios exclusivamente a los
				Usuarios registrados a través del Sitio Web y que acepten expresamente las condiciones
				particulares que sean de aplicación.
			</p>
			<p>
				ZARPAR se reserva el derecho de suspender y bloquear o eliminar el acceso de un usuario a
				este Sitio Web en caso de que incumpla cualquier disposición relativa a las condiciones de
				uso del mismo. Además ZARPAR se reserva la facultad de dar por terminado, modificar,
				suspender o interrumpir, temporalmente o de forma indefinida, en cualquier momento y sin
				necesidad de preaviso, el acceso a los servicios y/o contenidos del Sitio Web, así como la
				configuración misma del Sitio Web, prestaciones, servicios y contenidos, sin posibilidad por
				parte del Usuario de reclamar ni exigir indemnización alguna; en particular, con motivo de
				operaciones de mantenimiento, reparación, actualización, mejora y/o adecuación a cambios
				técnicos, operativos, de negocio y/o legales.
			</p>

			<li class="mt-4 text-lg font-semibold">Acceso y uso del sitio web</li>
			<p>
				El acceso al Sitio Web por parte de los Usuarios tiene carácter libre y gratuito. No
				obstante, la utilización, prestación y/o contratación de los servicios que, en su caso,
				puedan ser ofrecidos por ZARPAR puede estar sujeta a la previa aceptación de requisitos
				formales tales como la cumplimentación del correspondiente formulario, abono de precio o
				tasas y/o la previa aceptación de las condiciones particulares que resulten de aplicación a
				los mismos.
			</p>
			<p>
				El mero acceso al Sitio Web no implica, en sí mismo, el establecimiento de ningún tipo de
				vínculo o relación comercial entre ZARPAR y el Usuario, salvo cuando se hayan establecido
				los medios oportunos para ello y el Usuario haya dado cumplimiento previo a los requisitos
				que, en su caso, sean establecidos.
			</p>
			<p>
				La inclusión en el Sitio Web de información relativa a servicios ofrecidos por ZARPAR tiene
				exclusivamente fines informativos y publicitarios, salvo que sea establecida expresamente
				otra finalidad.
			</p>
			<p>
				Si para la utilización, prestación y/o contratación de algún producto o servicio ofrecido a
				través del Sitio Web, el Usuario debiera proceder a su registro o alta de usuario, éste será
				responsable de aportar información veraz y lícita, garantizando la autenticidad de todos
				aquellos datos que introduzca a la hora de cumplimentar los formularios preestablecidos para
				acceder a los productos o servicios de que se trate. Si como consecuencia del registro, el
				Usuario debiera disponer de una contraseña, éste se compromete a hacer un uso diligente y a
				mantener en secreto la misma.
			</p>
			<p>
				Los Usuarios son responsables de la adecuada custodia y confidencialidad de cualesquiera
				identificadores y/o contraseñas utilizados, y se comprometen a no ceder su uso a terceros,
				ya sea temporal o permanente, ni a permitir su acceso a personas ajenas. Será
				responsabilidad exclusiva del Usuario la utilización y/o contratación de los servicios por
				cualquier tercero ilegítimo que emplee a tal efecto una contraseña a causa de una actuación
				no diligente o de la pérdida de la misma por el Usuario.
			</p>
			<p>
				En virtud de lo anterior, es obligación del Usuario notificar de forma inmediata a ZARPAR
				cualquier hecho que permita el uso indebido de los identificadores y/o contraseñas, tales
				como el robo, extravío, o el acceso no autorizado a los mismos, con el fin de proceder a su
				inmediata cancelación. Sin perjuicio de cualquier otra disposición aquí contenida, mientras
				no se comuniquen tales hechos, ZARPAR quedará eximida de cualquier responsabilidad que
				pudiera derivarse del uso indebido de los identificadores o contraseñas por terceros no
				autorizados.
			</p>

			<li class="mt-4 text-lg font-semibold">Limitación de responsabilidad</li>
			<p>
				El Sitio Web y cualquier contenido y/o servicio ofrecido dentro del mismo son ofrecidos “tal
				cual”. El acceso, navegación y uso del Sitio Web y, en su caso, el uso o contratación de los
				servicios que sean ofrecidos a través del mismo tiene lugar bajo la única y exclusiva
				responsabilidad del Usuario, por lo que éste se compromete a observar diligente y fielmente
				cualquier instrucción adicional, impartida por ZARPAR o por personal autorizado de ZARPAR,
				relativa al uso del Sitio Web y sus contenidos.
			</p>
			<p>
				En este sentido, ZARPAR no se hace responsable y, en la máxima medida permitida por la
				legislación aplicable, excluye cualesquiera garantías, expresas o implícitas, relativas a la
				idoneidad para un fin concreto, cumplimiento, exactitud, fiabilidad, integridad o actualidad
				de los contenidos, servicios, productos, enlaces u otros elementos incluidos en el Sitio
				Web, o los resultados obtenidos de acceder y usar el Sitio Web y/o el contenido del mismo.
			</p>
			<p>En particular, ZARPAR no garantiza ni se hace responsable de:</p>
			<ul class="ml-4 mt-2 list-disc">
				<li>
					La posibles errores u omisiones en el contenido de la página web, de la falta de
					disponibilidad y/o accesibilidad de la misma o de la transmisión de programas maliciosos a
					través de la misma;
				</li>
				<li>
					La invulnerabilidad del Sitio Web y/o la inexpugnabilidad de las medidas de seguridad que
					se adopten en el mismo;
				</li>
				<li>
					Las incidencias en la red Internet o cualquier otra incidencia debida a causas de fuerza
					mayor y/o que estén fuera de su alcance y/o control.
				</li>
				<li>
					Los daños o perjuicios que cause, a sí mismo o a un tercero, cualquier persona que
					infringiera las condiciones, normas e instrucciones que ZARPAR establece en el Sitio Web o
					a través de la vulneración de los sistemas de seguridad del mismo;
				</li>
				<li>
					La pérdida de beneficios, ingresos, datos, interrupción de negocio, daños indirectos,
					especiales, derivados, ejemplares o punitivos derivados uso que terceros hagan de la
					información publicada en el Sitio Web, ni tampoco de los daños sufridos o pérdidas
					económicas que, de forma directa o indirecta, produzcan o puedan producir perjuicios
					económicos, materiales o sobre datos, provocados por el uso de dicha información.
				</li>
			</ul>

			<p></p>
			<li class="mt-4 text-lg font-semibold">Derechos de propiedad intelectual e industrial</li>

			<p>
				ZARPAR es titular o ha obtenido la correspondiente licencia sobre los derechos de
				explotación en materia de propiedad intelectual, industrial y de imagen sobre los contenidos
				disponibles a través del Sitio Web, entre otros a título meramente enunciativo y no
				exhaustivo: los textos, diseños gráficos, dibujos, códigos, software, fotografías, vídeos,
				sonidos, bases de datos, índices, imágenes, marcas, logotipos, expresiones e informaciones
				y, en general, cualquier otra creación protegida por las normas nacionales e internacionales
				sobre propiedad intelectual e industrial (en adelante, conjuntamente, los Contenidos).
			</p>
			<p>
				Quedan reservados todos los derechos de propiedad intelectual e industrial sobre los
				Contenidos y, en particular, queda prohibido modificar, copiar, reproducir, comunicar
				públicamente, transformar o distribuir de cualquier forma la totalidad o parte de los
				Contenidos incluidos en el Sitio Web, para propósitos públicos o comerciales, si no se
				cuenta con la autorización previa, expresa y por escrito de ZARPAR o, en su caso, del
				titular de los derechos a que corresponda.
			</p>
			<p>
				El acceso y navegación del Usuario por el Sitio Web en ningún caso se entenderá como una
				renuncia, transmisión, licencia o cesión total ni parcial de los derechos antes indicados
				por parte de ZARPAR.
			</p>
			<p>
				Las referencias a nombres y marcas comerciales o registradas, logotipos u otros signos
				distintivos, ya sean titularidad de ZARPAR o de terceras empresas, llevan implícitas la
				prohibición sobre su uso sin el consentimiento de ZARPAR o de sus legítimos propietarios. En
				ningún momento, salvo manifestación expresa el acceso o uso del Sitio Web y/o de sus
				Contenidos, confiere al usuario derecho alguno sobre las marcas, logotipos y/o signos
				distintivos en él incluidos protegidos por Ley.
			</p>

			<li class="mt-4 text-lg font-semibold">Enlaces</li>
			<span class="mt-4 font-semibold">6.1 Enlaces desde el Sitio Web a otras páginas web </span>
			<p>
				ZARPAR puede ofrecer enlaces, directa o indirectamente, a recursos o páginas web de Internet
				que se encuentran fuera del Sitio Web. La presencia de estos enlaces en el Sitio Web tiene
				una finalidad informativa, no constituyendo en ningún caso una invitación a la contratación
				de productos y/o servicios que se ofrezcan o puedan ofrecer en las páginas web de destino ni
				implica la existencia de vínculo o relación mercantil o de dependencia con la entidad
				titular de la página web enlazada. En estos casos, ZARPAR no será responsable de establecer
				las condiciones generales y particulares a tener en cuenta en la utilización, prestación o
				contratación de estos servicios por terceros y, por lo tanto, no podrá ser considerado
				responsable de los mismos.
			</p>
			<p>
				ZARPAR no asume ningún tipo de responsabilidad por cualquier aspecto relativo a las páginas
				web a las que se pudiera establecer un enlace desde el Sitio Web, incluido, a título
				enunciativo y no limitativo, su funcionamiento, acceso, datos, información, archivos,
				calidad y fiabilidad de sus productos y servicios, sus propios enlaces y/o cualquiera de sus
				contenidos, en general.
			</p>
			<p>
				Ello no obstante, en caso de que ZARPAR llegue a tener conocimiento efectivo de que la
				actividad o la información a la que se remite desde dichos enlaces es ilícita, constitutiva
				de delito o puede lesionar bienes o derechos de un tercero, actuará con la diligencia
				necesaria para suprimir o inutilizar el enlace correspondiente con la mayor brevedad
				posible.
			</p>
			<p>
				Asimismo, si los Usuarios tuvieran conocimiento efectivo de la ilicitud de actividades
				desarrolladas a través de estas páginas web de terceros, deberán comunicarlo inmediatamente
				a ZARPAR a los efectos de que se proceda a deshabilitar el enlace de acceso a la misma.
			</p>

			<li class="mt-4 text-lg font-semibold">Política de privacidad y Cookies</li>
			<p>
				Este Sitio Web cumple con la normativa vigente en materia de protección de datos de carácter
				personal. Para más información el Usuario puede consultar la <a
					href={localizeHref('/politica-de-privacidad')}
					class="font-semibold text-sky-500 hover:text-sky-600">Política de Privacidad</a
				>
				y la
				<a
					href={localizeHref('/politica-de-cookies')}
					class="font-semibold text-sky-500 hover:text-sky-600">Política de Cookies</a
				>.
			</p>
			<li class="mt-4 text-lg font-semibold">Duración y modificación</li>
			<p>
				ZARPAR se reserva el derecho de modificar el presente Aviso Legal y/o las condiciones de uso
				particulares (Términos y Condiciones) para la utilización y/o contratación de los servicios
				prestados a través del Sitio Web, cuando lo considere oportuno, con motivo de operaciones de
				mantenimiento, reparación, actualización, mejora y/o adecuación a cambios técnicos,
				operativos, de negocio y/o legales, siendo válidas y surtiendo sus efectos desde la
				publicación en el Sitio Web.
			</p>
			<p>
				La vigencia temporal de dichas normas coincide, por lo tanto, con el tiempo de su
				exposición, hasta que sean modificadas total o parcialmente, momento en el cual pasarán a
				tener vigencia las normas modificadas.
			</p>
			<li class="mt-4 text-lg font-semibold">Comunicaciones</li>
			<p>
				El Usuario podrá comunicarse con ZARPAR mediante los canales previstos en el Sitio Web
				(formularios de contacto), así como a la dirección postal y/o electrónica arriba indicadas.
				En todo caso, las comunicaciones de ZARPAR hacia el Usuario se realizarán de conformidad con
				los datos de contacto aportados o facilitados.
			</p>
			<li class="mt-4 text-lg font-semibold">Generalidades</li>
			<p>
				Los encabezamientos de las distintas cláusulas son sólo informativos, y no afectarán,
				calificarán o modificarán la interpretación del Aviso Legal.
			</p>
			<p>
				En caso de existir discrepancia entre lo establecido en este Aviso Legal y los Términos y
				Condiciones establecidos respecto de los servicios ofrecidos en el Sitio Web, prevalecerá lo
				dispuesto en los Términos y Condiciones.
			</p>
			<p>
				Si alguna de las disposiciones de este Aviso Legal fuese declarada total o parcialmente
				nula, se tendrá por no puesta, subsistiendo las demás.
			</p>
			<p>
				El no ejercicio o ejecución por parte de ZARPAR de cualquier derecho o disposición contenida
				en este Aviso Legal no constituirá una renuncia al mismo.
			</p>
			<li class="mt-4 text-lg font-semibold">Legislación aplicable y tribunales competentes</li>
			<p>
				El presente Aviso Legal y cualquier relación que surja de su aceptación o se relacione con
				el mismo se regirán exclusivamente por la legislación española que resulte de aplicación.
			</p>
			<p>
				El Usuario someterá cualesquiera controversias y/o litigios relativos al uso del Sitio Web,
				con renuncia expresa a cualquier otro fuero que pudiera corresponderle en la máxima medida
				permitida por la legislación aplicable, al conocimiento de los Juzgados y Tribunales de la
				ciudad de Vigo (España).
			</p>
		</ol>
	</div>
</div>
